module.exports = __webpack_public_path__ + "media/ios_notification.e56e9b96.mp3";